import instance from '../axios';

export const getAll = async () => {
  const response = await instance.get(`customers`);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`customers`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`customers`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`customers/` + id);
  return response;
};

export const transfer = async (data) => {
  const response = await instance.post(`customers/transfer`, data);
  return response;
};

export const passwordValidation = async (data) => {
  const response = await instance.post(`customers/password`, data);
  return response;
};
